import React, { Component } from 'react';

import {Card, CardHeader, CardText} from 'material-ui/Card';
import AccountCircle from 'material-ui/svg-icons/action/account-circle';
import Avatar from 'material-ui/Avatar'
import { FormattedMessage, intlShape } from 'react-intl';

const localeMessages = {
  firstContact: {
    id: "Supporter.Help.TechnicalContact",
    defaultMessage: "Technischer Kontakt (Erstkontakt)"
  },
  secondContact: {
    id: "Supporter.Help.TechnicalContact2",
    defaultMessage: "Technischer Kontakt (Zweitkontakt)"
  },
};

class Help extends Component {
  static contextTypes = {
    intl: intlShape.isRequired,
  }

  render() {
    return (
      <div style={{padding:'30px'}}>
        <div className="">
          <h2>
            <FormattedMessage
              id='Supporter.Help.Help'
              defaultMessage="Hilfe &amp; Support"
            /></h2>
          <p>
            <FormattedMessage
              id='Supporter.Help.HelpInstructions'
              defaultMessage="Bei Problemen versuchen Sie folgende Erste-Hilfe-Massnahmen:"
            />
          </p>
          <ol>
            <li>
              <FormattedMessage
                id='Supporter.Help.ReloadInstructions'
                defaultMessage="Laden Sie die Seite neu und loggen sich ein:"
              /> <a href="#" onClick={() => window.location.reload()}>
                <FormattedMessage
                  id='Supporter.Help.Reload'
                  defaultMessage="Seite neu laden"
                /></a></li>
            <li>
              <FormattedMessage
                id='Supporter.Help.NetworkInstructions'
                defaultMessage="Prüfen Sie Ihre Internetverbindung, dass Ihre Webcam angeschlossen ist und Ihre Lautsprecher laut genug eingestellt sind."
              />
            </li>
            <li>
              <FormattedMessage
                id='Supporter.Help.CoverInstructions'
                defaultMessage="Stellen Sie sicher, dass die Abdeckung Ihrer Webcam (falls vorhanden) offen ist bzw. die Webcam freie Sicht hat."
              />
            </li>
          </ol>
        </div>
        <div className="helpscreen" style={{marginTop: '30px'}}>
          <h3>
            <FormattedMessage
              id='Supporter.Help.DirectHelp'
              defaultMessage="Direkthilfe"
            />
          </h3>
          <p>
            <FormattedMessage
              id='Supporter.Help.CallInstructions'
              defaultMessage="Sollten Sie dennoch Probleme oder andere Fragen haben, kontaktieren Sie uns:"
            />
          </p>
          <div style={{display:'flex'}}>
            <Card style={{marginRight: '15px'}}>
              <CardHeader
                title="Dominique Sandoz"
                subtitle={this.context.intl.formatMessage(localeMessages.firstContact)}
                avatar={<Avatar
                  icon={<AccountCircle />}
                />}
              />
              <CardText>
                <p><a href="mailto:dominique.sandoz@vonwaldkirch.com">dominique.sandoz@vonwaldkirch.com</a></p>
                <p><a href="tel:0041786624350">+41 78 662 43 50</a></p>
              </CardText>
            </Card>
            <Card style={{marginLeft: '15px'}}>
              <CardHeader
                title="Christof von Waldkirch"
                subtitle={this.context.intl.formatMessage(localeMessages.secondContact)}
                avatar={<Avatar
                  icon={<AccountCircle />}
                />}
              />
              <CardText>
                <p><a href="mailto:christof@vonwaldkirch.com">christof@vonwaldkirch.com</a></p>
                <p><a href="tel:0041764292480">+41 76 429 24 80</a></p>
              </CardText>
            </Card>
          </div>
        </div>
      </div>
    )
  }
};

export default Help;


// WEBPACK FOOTER //
// ./src/Help.js